module.exports = __webpack_public_path__ + "css/TryStar.185a74ee.css";